import { render, staticRenderFns } from "./FeedActions.vue?vue&type=template&id=0874f8b9&"
import script from "./FeedActions.vue?vue&type=script&lang=js&"
export * from "./FeedActions.vue?vue&type=script&lang=js&"
import style0 from "./FeedActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports